import React from 'react';
import { motion } from 'framer-motion';
import { Network, UserCheck, Award, Globe, DollarSign, ShieldCheck, Headphones, Cloud, Check, ArrowRight } from 'lucide-react';
import { services } from '../mock/mock';

const iconMap = { Network, UserCheck, Award, Globe, DollarSign, ShieldCheck, Headphones, Cloud };

const Services = () => {
  return (
    <section id="services" className="section-padding section-mesh relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="container-x relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="eyebrow mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" /> Premium Services
          </motion.div>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="section-title">
            Hosting <span className="gradient-text">Services</span>
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }} className="section-subtitle mx-auto mt-4">
            Enterprise-grade infrastructure with the reliability, security and performance your workloads demand.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((svc, i) => {
            const Icon = iconMap[svc.icon] || Cloud;
            return (
              <motion.div
                key={svc.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="svc-card group relative p-6 rounded-2xl glass overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-cyan-500/10 blur-3xl group-hover:bg-cyan-500/20 transition-colors" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500/20 to-purple-500/20 border border-cyan-400/30 flex items-center justify-center mb-4 group-hover:from-cyan-500 group-hover:to-purple-500 transition-all">
                    <Icon className="text-cyan-300 group-hover:text-white transition-colors" size={22} />
                  </div>
                  <h3 className="text-lg font-bold text-white">{svc.title}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{svc.description}</p>
                  <ul className="mt-4 space-y-1.5">
                    {svc.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-xs text-slate-300">
                        <Check size={14} className="text-cyan-400 mt-0.5 shrink-0" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5 pt-4 border-t border-white/5 flex items-center text-cyan-300 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                    Learn more <ArrowRight size={12} className="ml-1" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
